module.exports = __webpack_public_path__ + "static/media/avatar.a2a67d5f.png";